import React, { FunctionComponent } from 'react';
import { useRouter } from 'next/router';
import { SelectInputField } from '@havenengineering/module-shared-library/dist/form/components/SelectInput';
import { TextInputField } from '@havenengineering/module-shared-library/dist/form/components/TextInput';
import useForm from '@havenengineering/module-shared-library/dist/form/hooks/useForm';
import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';

import { formErrorHandling } from '../../../helpers/googleTag';
import { getRefundType } from '../../../helpers/refund';
import { RefundForm } from '../../../types/refund';

type SecurityQuestionsForm = {
  secQuest1: string;
  secQuest1Answ: string;
  secQuest2: string;
  secQuest2Answ: string;
};

type SecurityQuestionsStepForm = Pick<RefundForm, 'security'>;
interface SecurityQuestionsProps {
  state: RefundForm;
  handleStepChange: (changedForm: SecurityQuestionsStepForm) => void;
}

export const SecurityQuestions: FunctionComponent<SecurityQuestionsProps> = ({
  state,
  handleStepChange,
}) => {
  const router = useRouter();
  const isLettingIncomeRefund = router.query.type === 'letting-income';

  const options = [
    { label: 'What is your Surname?', value: 'surname' },
    { label: 'What is your Mobile Number?', value: 'mobile' },
    { label: 'What is your Post Code?', value: 'postalCode' },
    { label: 'What is your Pitch number?', value: 'pitchNumber' },
  ];

  const { fields, submit } = useForm<SecurityQuestionsForm>({
    initialState: {
      secQuest1: state?.security?.secQuest1 || '',
      secQuest1Answ: state?.security?.[state?.security?.secQuest1] || '',
      secQuest2: state?.security?.secQuest2 || '',
      secQuest2Answ: state?.security?.[state?.security?.secQuest2] || '',
    },
    schema: {
      secQuest1: {
        required: true,
      },
      secQuest1Answ: {
        required: true,
      },
      secQuest2: {
        required: true,
      },
      secQuest2Answ: {
        required: true,
      },
    },
    submitCallback: async (state) => {
      const security = {
        secQuest1: state.secQuest1,
        [state.secQuest1]: state.secQuest1Answ,
        secQuest2: state.secQuest2,
        [state.secQuest2]: state.secQuest2Answ,
      };
      handleStepChange({ security });
    },
    errorCallback: (fields) => {
      const errors = Object.keys(fields).map((key: string) => {
        const field = fields[key as keyof SecurityQuestionsForm];
        return {
          getErrorMessage: () => field.error,
          props: {
            name: field.name,
            label: '',
          },
        };
      }) as any[];
      formErrorHandling(getRefundType(isLettingIncomeRefund), errors);
    },
  });

  return (
    <form onSubmit={(event) => event.preventDefault()}>
      <p className="owners-body">
        To verify your account details, please answer the following questions.
      </p>
      <SelectInputField
        id="secQuest1"
        label="Account Question 1"
        options={options}
        field={fields.secQuest1 as any}
      />
      <TextInputField
        id="secQuest1Answ"
        label="Answer 1"
        field={fields.secQuest1Answ}
        disabled={!fields.secQuest1.value}
      />
      <SelectInputField
        id="secQuest2"
        label="Account Question 2"
        options={options}
        field={fields.secQuest2 as any}
      />
      <TextInputField
        id="secQuest2Answ"
        label="Answer 2"
        field={fields.secQuest2Answ}
        disabled={!fields.secQuest2.value}
      />
      <Button type="submit" fullWidth onClick={() => submit()}>
        Continue
      </Button>
    </form>
  );
};
